<template>
  <k-dialog @close="cancel" :max-width="400" :title="action">
    <form class="k-form" @submit.prevent="save">
      <div style="width: 50vw">
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Tenant Name :
          </label>
          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'name'"
              v-model="tenantInEdit.name"
              class="form-control"
              required
            ></k-input>
          </div>
        </div>
        <div
          class="form-group row"
          :style="{ marginBottom: '1rem' }"
          v-if="!isEdit"
        >
          <label class="col-sm-3 text-left col-form-label"> Tenant ID : </label>
          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'id'"
              v-model="tenantInEdit.id"
              class="form-control"
            ></k-input>
          </div>
        </div>
        <div
          class="form-group row"
          :style="{ marginBottom: '1rem' }"
          v-if="!isEdit"
        >
          <label class="col-sm-3 text-left col-form-label">
            Redirect URI :
          </label>
          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'redirecturi'"
              v-model="tenantInEdit.redirectUri"
              class="form-control"
            ></k-input>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Is Tenant Active?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="tenantInEdit.isActive"
              :messages="messages"
              v-model="tenantInEdit.isActive"
              :name="'isTenantActive'"
            ></kendo-switch>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Is External Registration Allowed?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="tenantInEdit.isExternalRegAllowed"
              :messages="messages"
              v-model="tenantInEdit.isExternalRegAllowed"
              :name="'isExternalRegAllowed'"
            ></kendo-switch>
          </div>
        </div>
        <div v-if="tenantInEdit.id">
          <div class="form-group row" :style="{ marginBottom: '1rem' }">
            <label class="col-sm-3 text-left col-form-label">
              Tenant Logo :
            </label>
            <div class="col-sm-6">
              <input
                type="file"
                ref="file"
                @change="onLogoChange"
                class="imageButton"
                accept="image/*"
              />
            </div>
          </div>

          <p class="col-sm-6 offset-sm-3" v-if="logoName">{{ logoName }}</p>

          <p class="col-sm-6 offset-sm-3" v-else-if="tenantInEdit.imagePath">
            {{ tenantInEdit.imagePath }}
          </p>

          <div class="form-group row" :style="{ marginBottom: '1rem' }">
            <label class="col-sm-3 text-left col-form-label">
              Tenant Background Image :
            </label>
            <div class="col-sm-6">
              <input
                type="file"
                ref="file1"
                @change="onBGChange"
                class="imageButton"
                accept="image/*"
              />
            </div>
          </div>
        </div>
        <p class="col-sm-6 offset-sm-3" v-if="bgName">{{ bgName }}</p>

        <p
          class="col-sm-6 offset-sm-3"
          v-else-if="tenantInEdit.backgroundImagePath"
        >
          {{ tenantInEdit.backgroundImagePath }}
        </p>

        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Select Layout :
          </label>

          <div class="col-sm-2 pt-2" v-for="item in layouts" :key="item.id">
            <div class="d-flex flex-column">
              <input
                class="m-auto"
                v-model="tenantInEdit.loginLayout"
                type="radio"
                name="layout"
                :id="item.id"
                :value="item.name"
                required
              />
              <p class="text-capitalize">{{ item.name }}</p>
              <img
                :src="'/static/layout' + item.id + '.png'"
                style="margin: auto; height: auto; width: 70px"
                alt="layoutimage"
              />
            </div>
          </div>
        </div>
      </div>
      <input type="submit" id="submit-form" class="d-none" />
    </form>

    <div class="d-flex ">
      <button class="k-button col-6" @click="cancel" >Cancel</button>
      <label class="k-button k-primary col-6 mb-0" for="submit-form" tabindex="0"
        >Save</label
      >
    </div>
  </k-dialog>
</template>
<script>
import { Dialog, DialogActionsBar } from "@progress/kendo-vue-dialogs";
import { NumericTextBox, Input } from "@progress/kendo-vue-inputs";
import { required } from "vuelidate/lib/validators";
import { Switch } from "@progress/kendo-inputs-vue-wrapper";
import { Upload } from "@progress/kendo-upload-vue-wrapper";
import "@progress/kendo-ui/js/kendo.core";
import "@progress/kendo-ui/js/kendo.switch";
export default {
  components: {
    "k-input": Input,
    numerictextbox: NumericTextBox,
    "k-dialog": Dialog,
    "dialog-actions-bar": DialogActionsBar,
    "kendo-switch": Switch,
    upload: Upload,
  },
  props: {
    dataItem: Object,
    dialogTitle: String,
    layouts: Array,
  },
  data: function () {
    return {
      tenantInEdit: {
        name: "",
        logo: undefined,
        loginLayout: undefined,
      },
      isEdit: false,
      logoName: undefined,
      bgName: undefined,
      action: "",
      multiselectValue: [],
      messages: {
        checked: "Yes",
        unchecked: "No",
      },
    };
  },
  validations: {
    tenantInEdit: {},
  },
  created: function () {
    if (this.$props.dataItem) {
      this.tenantInEdit = this.$props.dataItem;
    }
    this.action = this.$props.dialogTitle;
    if (this.action == "Edit Tenant") this.isEdit = true;
  },
  methods: {
    onLogoChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      console.log(files.length);
      this.tenantInEdit.logo = files[0];
      this.logoName = files[0].name;
      console.log(this.tenantInEdit.logo);
    },
    onBGChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      console.log(files.length);
      this.tenantInEdit.backgroundImage = files[0];
      this.bgName = files[0].name;
      console.log(this.tenantInEdit.backgroundImage);
    },
    cancel() {
      this.$emit("cancel");
    },
    save() {
      console.log("SAVED");
      if (this.action == "Edit Tenant") {
        this.$emit("save");
      } else {
        this.$emit("save");
      }
    },
  },
};
</script>
<style scoped>
.imageButton {
  display: block;
  position: relative;
  width: 100%;
  margin: auto;
  cursor: pointer;
  border: 0;
  height: 30px;
  color: transparent;
  border-radius: 5px;
  outline: 0;
}
.imageButton:hover:after {
  background: #79ccf0;
}
.imageButton:after {
  transition: 200ms all ease;
  border-bottom: 3px solid rgba(0, 0, 0, 0.2);
  background: #f1f1f1;
  color: #000;
  font-size: 15px;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  content: "Upload Image";
  line-height: 30px;
  border-radius: 5px;
}
</style>